jQuery(document).ready(function ($) {
	new WOW().init();
	submenus();
	hamburgerFunction();
	// var header_second = $(".header_second");

	// $(window).resize(() => {
	//   console.log("RESIZING");
	// });

	//HEADER FIXED ON SCROLL
	// async function showHeaderOnScroll() {
	//   $(window).scroll(function () {
	//     var scroll = $(window).scrollTop();
	//     if (scroll >= 100) {
	//       header_second.addClass("header_second_active");
	//     } else {
	//       header_second.removeClass("header_second_active");
	//     }
	//   });
	// }

	//HEADER WITH HAMBURGER MENU
	async function hamburgerFunction() {
		$(".hamburger").click((e) => {
			$(".hamburger").toggleClass("hamburger_active");
			$(".list").toggleClass("list_active");
			$(".list__mobile").toggleClass("list__mobile_active");
		});

		$(".header-mobile .menu-item-has-children").click(function (e) {
			e.stopPropagation();
			$(this).toggleClass("active");
			$(this).find("> ul.sub-menu").toggleClass("active");
		});
	}

	async function submenus() {
		const submenuListItemSelector =
			".header_second .menu > li.menu-item-has-children > ul.sub-menu li.menu-item-has-children";
		$(submenuListItemSelector).click(function (e) {
			//close all opened elements

			// $(`${submenuListItemSelector} ul.sub-menu`).removeClass("sub-menu-opened");
			// $(`${submenuListItemSelector} > a`).removeClass("underlineMe");
			// $(submenuListItemSelector).removeClass("activeTriangle");
			//trigger opening this submenu
			// e.preventDefault();
			const clickedLi = $(this);
			const clickedUl = clickedLi.children("ul.sub-menu");
			clickedUl.toggleClass("sub-menu-opened");
			clickedLi.find(">a").toggleClass("underlineMe");
			clickedLi.toggleClass("activeTriangle");
		});
	}

	//MAIN SLIDER ON POST PAGE
	// $(".post-images").slick({
	//   slidesToShow: 1,
	//   slidesToScroll: 1,
	//   arrows: true,
	//   fade: false,
	//   asNavFor: ".post-nav-slider",
	// });

	function ThumbnailPlugin(main) {
		return (slider) => {
			let arrowLeft, arrowRight;

			function listenArrows(slider) {
				arrowLeft = document.querySelector(
					".slider-navigation-wrapper .arrow--left"
				);
				arrowRight = document.querySelector(
					".slider-navigation-wrapper .arrow--right"
				);
				arrowLeft.addEventListener("click", () => {
					console.log("click on arrow left");
					slider.prev();
				});
				arrowRight.addEventListener("click", () => {
					console.log("click on arrow right");
					slider.next();
				});
			}

			function updateClasses(mainSlider) {
				var slide = mainSlider.track.details.rel;
				slide === 0
					? arrowLeft.classList.add("arrow--disabled")
					: arrowLeft.classList.remove("arrow--disabled");
				slide === mainSlider.track.details.slides.length - 1
					? arrowRight.classList.add("arrow--disabled")
					: arrowRight.classList.remove("arrow--disabled");
			}

			function removeActive() {
				slider.slides.forEach((slide) => {
					slide.classList.remove("active");
				});
			}

			function addActive(idx) {
				slider.slides[idx].classList.add("active");
			}

			function addClickEvents() {
				slider.slides.forEach((slide, idx) => {
					slide.addEventListener("click", () => {
						main.moveToIdx(idx);
					});
				});
			}

			main.on("slideChanged", () => {
				updateClasses(main);
			});

			slider.on("created", () => {
				addActive(slider.track.details.rel);
				listenArrows(main);
				addClickEvents();
				main.on("animationStarted", (main) => {
					removeActive();
					const next = main.animator.targetIdx || 0;
					addActive(main.track.absToRel(next));
					slider.moveToIdx(
						Math.min(slider.track.details.maxIdx, next)
					);
				});
			});
		};
	}

	const mainSlider = document.querySelector(".post-images");
	if (mainSlider) {
		var slider = new KeenSlider(".post-images");
		var thumbnails = new KeenSlider(
			".post-nav-slider",
			{
				initial: 0,
				slides: {
					perView: 4,
					spacing: 10,
				},
			},
			[ThumbnailPlugin(slider)]
		);
	}

	const fancyBoxes = document.querySelector('[data-fancybox="gallery"]');
	if (fancyBoxes) {
		Fancybox.bind('[data-fancybox="gallery"]', {});
	}

	//FOOTER NAVIGATION FOR SUBCHILDREN
	$(".footer-menu__main .menu-item-has-children > a").click(function (e) {
		e.preventDefault();
		// $(".footer-menu__main .menu-item-has-children .sub-menu").removeClass(
		//   "sub-menu_active"
		// );
		$(this).toggleClass("opened");
		$(this).next("ul.sub-menu").toggleClass("sub-menu_active");
	});

	function stopPropagationForHashLinks() {
		// Select all <a> tags with href="#"
		const hashLinks = document.querySelectorAll('a[href="#"]');
		const emptyLinks = document.querySelectorAll('a[href="#empty"]');

		// Attach click event listener to each matching link
		hashLinks.forEach((link) => {
			link.addEventListener("click", function (event) {
				// Prevent default behavior (e.g., following the link)
				event.preventDefault();
			});
		});

		emptyLinks.forEach((link) => {
			link.addEventListener("click", function (event) {
				// Prevent default behavior (e.g., following the link)
				event.preventDefault();
			});
		});
	}

	// Call the function to apply the behavior
	stopPropagationForHashLinks();

	$("#scrollUp").click(() => {
		if ($(window).scrollTop() > window.innerHeight * 0.85) {
			window.scroll({
				top: 0,
				behavior: "smooth",
			});
		}
	});

	function handleScroll() {
		const scrollUpButton = $("#scrollUp");
		if ($(window).scrollTop() > window.innerHeight * 0.85) {
			// Scrolled more than 100vh, add the class
			scrollUpButton.addClass("scroll-page-up_active");
		} else {
			// Scrolled less than 100vh, remove the class
			scrollUpButton.removeClass("scroll-page-up_active");
		}
	}

	function clickableLanguage() {
		const ACTIVE_CLASS = "clickableLanguage-switcher_active";
		const rootEl = document.querySelector(".clickableLanguage");
		if (rootEl) {
			const switcher = rootEl.querySelector(
				".clickableLanguage-switcher"
			);

			rootEl.addEventListener("click", () => {
				const isActive = switcher.classList.contains(ACTIVE_CLASS);

				if (isActive) {
					switcher.classList.remove(ACTIVE_CLASS);
				} else {
					switcher.classList.add(ACTIVE_CLASS);
				}
			});
		}
	}

	// Initial call to handle scroll position on page load
	handleScroll();
	clickableLanguage();

	// Add event listener for the scroll event
	$(window).scroll(function () {
		// Call the handleScroll function on scroll
		handleScroll();
	});
});
